import { render, staticRenderFns } from "./PickUpReceipt.vue?vue&type=template&id=24063d20&scoped=true"
import script from "./PickUpReceipt.vue?vue&type=script&lang=js"
export * from "./PickUpReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24063d20",
  null
  
)

export default component.exports